import type { RunbookProcessResource, RunbookSnapshotTemplateResource } from "~/client/resources";
import type { Client } from "../client";
import BasicRepository from "./basicRepository";

class RunbookProcessRepository extends BasicRepository<RunbookProcessResource, RunbookProcessResource> {
    constructor(client: Client) {
        super("RunbookProcesses", client);
    }
    getRunbookSnapshotTemplate(runbookProcess: RunbookProcessResource, runbookSnapshotId: string) {
        return this.client.get<RunbookSnapshotTemplateResource>(runbookProcess.Links["RunbookSnapshotTemplate"], { runbookSnapshotId });
    }
}
export default RunbookProcessRepository;
